<div class="content ingame main-menu">
  <div class="message-panel" [@menuAnimation] *ngIf="menuIn" (@menuAnimation.done)="menuLeaves()">
    <div class="message-panel-background"></div>
    <div class="border-line">
    </div>
    <div class="message-panel-content">
      <div class="character-wrapper">
        <div class="character character3"></div>
      </div>
      <div class="buttons">
        <div class="button-menu" *ngFor="let button of buttons" (click)="button.action()">
          <span>{{button.text}}</span>
        </div>
      </div>


    </div>
  </div>
</div>
